import React from "react";
import { weAreArshContent } from "../../content/home/weAreArshContent";

const WeAreArsh: React.FC = () => {
    const { title, paragraphs } = weAreArshContent;

    return (
        <section className="bg-[#D4A752] text-[#111111] py-20">
            <div className="max-w-5xl mx-auto px-4 md:flex gap-12">

                <div className="md:w-1/3">
                    <h2
                        className="text-[56px] font-normal mb-4 leading-[75px]"
                        style={{ fontFamily: "Roboto Serif" }}
                    >
                        {title.map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                        ))}
                    </h2>
                </div>

                <div className="hidden md:block w-px bg-[#111111] opacity-30" />

                <div className="md:w-2/3 text-[24px] leading-relaxed space-y-6">
                    {paragraphs.map((para, index) => (
                        <p key={index}>{para}</p>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WeAreArsh;